import { baseBuild } from '@/core/services/network/config/baseBuild';
import type { AppDispatch } from '@/app/store/store';
import { createCustomizationService } from '../application/services/CustomizationService';
import { CustomizationAdapter } from '../infra/adapters/customization.adapter';

export function customizationBuild(dispatch: AppDispatch) {
  return baseBuild(
    (d: AppDispatch) => new CustomizationAdapter(d),
    (repo) => createCustomizationService(repo),
    dispatch,
  );
}
